import type { HelpFile } from '../../types/help'
import { ScriptEditorCoreTestIds } from '../../../testids/ScriptEditorCoreTestIds'

export const scriptEditorCoreHelp: HelpFile = {
  docPage: '/docs/jobs/script-editor',
  texts: {
    [ScriptEditorCoreTestIds.scriptEditorCore]:
      'Code-Editor mit Syntaxprüfung und KI-Unterstützung zum Schreiben von Job- und Konnektor-Skripten.',
    [ScriptEditorCoreTestIds.assistError]:
      'Fehler vom KI-Assistenten — den Prompt überarbeiten oder erneut versuchen.',
    [ScriptEditorCoreTestIds.assistPanel]:
      'Seitenbereich, in dem der KI-Assistent Skript-Änderungen und Verbesserungen vorschlägt.',
    [ScriptEditorCoreTestIds.assistPanelBody]: null,
    [ScriptEditorCoreTestIds.assistSuggestion]:
      'Ein Vorschlag des KI-Assistenten; kann angewendet werden, um das aktuelle Skript zu ersetzen.',
    [ScriptEditorCoreTestIds.badgeSyntaxOk]: null,
    [ScriptEditorCoreTestIds.btnApplySuggestion]: null,
    [ScriptEditorCoreTestIds.btnCancelReplace]: null,
    [ScriptEditorCoreTestIds.btnCheckSyntax]:
      'Skript auf Syntaxfehler prüfen, ohne es auszuführen.',
    [ScriptEditorCoreTestIds.btnCloseAssist]: null,
    [ScriptEditorCoreTestIds.btnConfirmReplace]: null,
    [ScriptEditorCoreTestIds.btnFixWithAi]:
      'Den KI-Assistenten bitten, den markierten Syntaxfehler zu beheben.',
    [ScriptEditorCoreTestIds.btnInsertAtCursor]:
      'Vorschlag an der aktuellen Cursorposition einfügen, statt das gesamte Skript zu ersetzen.',
    [ScriptEditorCoreTestIds.btnInsertSql]: null,
    [ScriptEditorCoreTestIds.btnShowAllErrors]: null,
    [ScriptEditorCoreTestIds.btnSuggest]: null,
    [ScriptEditorCoreTestIds.btnToggleAssist]: null,
    [ScriptEditorCoreTestIds.editorContainer]: null,
    [ScriptEditorCoreTestIds.editorCoreSqlToolbar]:
      'SQL-spezifische Symbolleiste zum Einfügen eines schemabewussten SQL-Snippets in das Skript.',
    [ScriptEditorCoreTestIds.editorCoreToolbar]: null,
    [ScriptEditorCoreTestIds.errorSummaryBar]:
      'Kompakte Übersicht der im Skript erkannten Syntaxfehler.',
    [ScriptEditorCoreTestIds.inputAssistRequest]: null,
    [ScriptEditorCoreTestIds.rateLimitWarning]:
      'Anfragen an den KI-Assistenten sind ratenbegrenzt; vor der nächsten Anfrage warten.',
  },
}
